import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface OnboardingState {
  isActive: boolean;
  currentStep: number;
  totalSteps: number;
}

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  private onboardingStateSubject = new BehaviorSubject<OnboardingState>({
    isActive: false,
    currentStep: 0,
    totalSteps: 3
  });

  public onboardingState$ = this.onboardingStateSubject.asObservable();
  private onboardingCompleted = false;

  constructor() {}

  hasCompletedOnboarding(): boolean {
    return this.onboardingCompleted;
  }

  markOnboardingCompleted(): void {
    this.onboardingCompleted = true;
    this.closeOnboarding();
  }

  shouldShowOnboarding(hasDataspaces: boolean = false): boolean {
    return !hasDataspaces && !this.onboardingCompleted;
  }

  startOnboarding(): void {
    const newState: OnboardingState = {
      isActive: true,
      currentStep: 0,
      totalSteps: 3
    };
    this.onboardingStateSubject.next(newState);
  }

  nextStep(): void {
    const currentState = this.onboardingStateSubject.value;
    if (currentState.currentStep < currentState.totalSteps - 1) {
      const newState: OnboardingState = {
        ...currentState,
        currentStep: currentState.currentStep + 1
      };
      this.onboardingStateSubject.next(newState);
    } else {
      this.completeOnboarding();
    }
  }

  completeOnboarding(): void {
    this.markOnboardingCompleted();
  }

  closeOnboarding(): void {
    const newState: OnboardingState = {
      isActive: false,
      currentStep: 0,
      totalSteps: 3
    };
    this.onboardingStateSubject.next(newState);
  }

  getOnboardingState(): OnboardingState {
    return this.onboardingStateSubject.value;
  }

  initializeOnboardingForNewUsers(hasDataspaces: boolean): void {
    if (this.shouldShowOnboarding(hasDataspaces)) {
      this.startOnboarding();
    }
  }
}

